import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useLang } from "@/i18n";
import { ALL_PAGES } from "@/content";
import { INSIGHTS } from "@/content/pages-insights";

const BRAND = "Columbus Management Consulting GmbH";

const SITE_DESC = {
  fr: "Conseil indépendant en gestion et structuration de patrimoine à Zurich pour investisseurs, family offices et entreprises. Columbus Management Consulting GmbH.",
  en: "Independent business and management advisory in Zurich for investors, family offices and companies. Columbus Management Consulting GmbH.",
  de: "Unabhängige Unternehmens- und Managementberatung in Zürich für Investoren, Family Offices und Unternehmen. Columbus Management Consulting GmbH.",
};

const STATIC_TITLES = {
  "/": { fr: "Conseil en gestion indépendant à Zurich", en: "Independent management advisory in Zurich", de: "Unabhängige Unternehmensberatung in Zürich" },
  "/contact": { fr: "Contact", en: "Contact", de: "Kontakt" },
  "/insights": { fr: "Insights & analyses", en: "Insights & analysis", de: "Insights & Analysen" },
  "/verification": { fr: "Vérification KYC", en: "KYC verification", de: "KYC-Verifizierung" },
  "/aml-crypto": { fr: "AML Crypto — Partenaire de vérification", en: "AML Crypto — Verification partner", de: "AML Crypto — Verifizierungspartner" },
};

/**
 * Per-route document meta. Absolute-URL tags (canonical, og:url) are intentionally
 * omitted until the production domain is confirmed — a wrong canonical is worse than none.
 */
export const Seo = () => {
  const { lang } = useLang();
  const { pathname } = useLocation();

  let title = STATIC_TITLES[pathname]?.[lang];

  if (!title && pathname.startsWith("/insights/")) {
    const slug = pathname.split("/").pop();
    title = INSIGHTS.find((a) => a.slug === slug)?.title?.[lang];
  }

  if (!title) {
    const page = ALL_PAGES.find((p) => `/${p.slug}` === pathname);
    title = page?.[lang]?.title;
  }

  const fullTitle = title ? `${title} — ${BRAND}` : BRAND;
  const noindex = pathname === "/admin";

  return (
    <Helmet>
      <html lang={lang} />
      <title>{fullTitle}</title>
      <meta name="description" content={SITE_DESC[lang] || SITE_DESC.fr} />
      <meta property="og:title" content={fullTitle} />
      <meta name="twitter:title" content={fullTitle} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
};
